import React, { useContext, useEffect } from 'react';
import { NumericFormat } from 'react-number-format';
import { ShopperContext } from '../context/shopper';
import HeadingBuilder from '../components/HeadingBuilder';
import * as Constants from '../constants'
import { SelectOption } from "./SelectOption";
import { ErrorList } from './ErrorList';
import { useForm } from "../hooks/useForm";
import { useStyles } from "../hooks/useStyles";
import { useLookups, usePhrasing } from "../hooks/useSkuUtils";
import { useParams } from 'react-router-dom';
import Table from 'react-bootstrap/Table';
import { BackButton } from './BackButton';
import { useTranslation } from "react-i18next";
//import styled from 'styled-components';
import styles from '../css/trTdFirstChild.module.css';

export const CircleEditForm = () => {
    const { signedIn, shopper, circles, editCircle } = useContext(ShopperContext);
    const { errorsDoExist, dismissErrorsList, setErrorsDoExistToFalse } = useContext(ShopperContext);
    const { setJustGotClearToFalse } = useContext(ShopperContext);
    console.log('cef circles: ', circles)

    const { tableShow, tableData } = useStyles();
    const { lookupXipLength, lookup_tz_info } = useLookups();

    const {id} = useParams();
    console.log('cef id: ', id)

    const { t } = useTranslation();

    const { circleTaxTippyText,
            circleFoodTaxTippyText,
            postalCodeTippyText } = usePhrasing();
    const circleTaxText     = circleTaxTippyText();
    const circleFoodTaxText = circleFoodTaxTippyText();

    const circleObj = circles.find(c => c.id == id);
    console.log('cef circleObj: ', circleObj)

    useEffect(() => {
      dismissErrorsList();
    }, [dismissErrorsList]);

    if (circleObj == null) {
      console.log('cef circleObj2: ', circleObj)
      // User likely used browser to refresh the page, lost access to state.
      // This causes 'circleObj' to be 'undefined'.
      // Let's go back to the 'circles' page.
      window.location.replace('/circles/');
      // not sure why, but code below continues executing.
      // I'm thinking it would be better to suspend such processing but I
      // don't know how. Using 'navigate' here to go to /circles doesn't work.
      // As such, lack of 'circleObj' causes errors to arise below, but
      // at some point the effect of 'replace' kicks in and the shopper
      // is viewing '/circles/' cleanly. Seems like state is ok, but
      // I have not tested thoroughly.
    }

    const initialState = {
      id:         circleObj.id,
      identifier: circleObj.identifier,
      label:      circleObj.label,
     postal_code: circleObj.postal_code,
      time_zone:  circleObj.time_zone || "Eastern Time (US & Canada)",
      symbology:  circleObj.symbology || 'upca',
    topoff_level: circleObj.topoff_level,
      share_sku_basic:
                  circleObj.share_sku_basic ? 1 : 0,
      tax_rate:   circleObj.tax_rate || 0,
      tax_rate_food:
                  circleObj.tax_rate_food || 0,
      // detail: '',
      // img_url: '',
      // city: '',
      // county: '',
      // state: '',
      shopper_is_leader:
                  circleObj.leader_id === shopper.id,
    };
    console.log("cef: initialState", initialState);

    const { formData, handleChange, reset, editFormValues } = useForm(initialState);

    const postalCodeText = postalCodeTippyText({
      countryCode: circleObj.country,
      xipLength:   lookupXipLength({ countryCode: circleObj.country })
    });

    const timeZoneOptions = Constants.VALID_TIME_ZONES.map(
      timeZoneCode =>
        <SelectOption
          key      = {timeZoneCode}
          optValue = {lookup_tz_info({tz_term: timeZoneCode })}
          optLabel = {t('circle.tz_name.' + timeZoneCode)}
        />
    );

    // Labels are positional against Constants.TOPOFF_LEVELS:
    // optionValue0 is '100% (no top off)', optionValue10 is '50% (top off 50%)'
    const topoffOptions = Constants.TOPOFF_LEVELS.map(
      (level, idx) =>
        <SelectOption
          key      = {level}
          optValue = {level}
          optLabel = {t('circle.topoff.optionValue' + idx)}
        />
    );

    if (signedIn) {
        const handleSubmit = (e) => {
            e.preventDefault();

            // clear out any error messages, success statuses
            dismissErrorsList();
            setErrorsDoExistToFalse();
            setJustGotClearToFalse();
        
            console.log('formData for editCircle: ', formData);
            editCircle(formData);
        
            // If there is an error we want to preserve formData and show the message.
        }

        return (
          <article>
            <HeadingBuilder
              Size           = 'h3'
              headingText    = {t('circleEditForm.formPart.headlineLabel')}
              value          = {circleObj.identifier}
              // Update Circle: oipuy
              tippyAlertText = {t('circleEditForm.formPart.headlineTippyContent')}
              tippyText      = {t('circleEditForm.formPart.headlineTippyContent')}
            />
            <form onSubmit={handleSubmit}>
<Table responsive striped bordered hover size="sm" style={tableShow}>
  <thead >
  </thead>
  <tbody className={styles.trTdFC} style={tableData} >
    <tr>
      <td>
        <HeadingBuilder
          containerType  = 'container-input-label'
          headingText    = {t('circle.identifier.label')}
          // Shopping Circle ID
          labelHtmlFor   = "identifier_cef"
          tippyAlertText = {t('circle.identifier.tippyContent')}
          tippyText      = {t('circle.identifier.tippyContent')}
        />
      </td>
      <td>
        <input
          key="20"
          type="text"
          style={{ textTransform: "lowercase" }}
          id="identifier_cef"
          name="identifier"
          // autoComplete="username"
          onChange={handleChange}
          value={formData.identifier}
        />
      </td>
    </tr>
    <tr>
      <td>
        <HeadingBuilder
          containerType  = 'container-input-label'
          headingText    = {t('circle.label.label')}
          // Shopping Circle Descriptive Name
          labelHtmlFor   = "label_cef"
          tippyAlertText = {t('circle.label.tippyContent')}
          tippyText      = {t('circle.label.tippyContent')}
        />
      </td>
      <td>
        <textarea
          key="30"
          type="text"
          id="label_cef"
          name="label"
          onChange={handleChange}
          value={formData.label}
        />
      </td>
    </tr>
    <tr>
      <td>
        <HeadingBuilder
          containerType  = 'container-input-label'
          headingText    = {t('circle.country.label') + ' / '
                                                  + t('global.label.currency')}
          // Country / currency
          tippyAlertText = {t('circle.country.tippyContentEdit')}
          tippyText      = {t('circle.country.tippyContentEdit')}
          // Your Circle is based in this country and uses this currency.
        />
      </td>
      <td>
        {t('circle.country.optionValue' + circleObj.country) + ' / '
                                        + circleObj.currency_symbol}
        {/* lookup of 'circle.country.optionValueUS' becomes 'United States' */}
      </td>
    </tr>
    <tr>
      <td>
        <HeadingBuilder
          containerType  = 'container-input-label'
          headingText    = {t('circle.postal_code.label')}
          // Zip Code
          labelHtmlFor   = "postal_code_cef"
          tippyAlertText = {postalCodeText}
          tippyText      = {postalCodeText}
        />
      </td>
      <td>
        <input
          key="40"
          type="text"
          id="postal_code_cef"
          name="postal_code"
          onChange={handleChange}
          value={formData.postal_code}
          required
        />
        &nbsp;*
      </td>
    </tr>
    <tr>
      <td>
        <HeadingBuilder
          containerType  = 'container-input-label'
          headingText    = {t('circle.time_zone.label')}
          // Time Zone
          labelHtmlFor   = "time_zone_cef"
          tippyAlertText = {t('circle.time_zone.tippyContent')}
          tippyText      = {t('circle.time_zone.tippyContent')}
          // Where will your circle operate?
        />
      </td>
      <td>
        <select
          key="50"
          type="text"
          id="time_zone_cef"
          name="time_zone"
          onChange={handleChange}
          value={formData.time_zone}
        >
          {/* <option value="">Choose one:/option> */}
          <option value='' disabled>{t('global.chooseOne')}</option>

          {timeZoneOptions}
        </select>
        &nbsp;*
      </td>
    </tr>
    <tr>
      <td>
        <HeadingBuilder
          containerType='container-input-label'
          headingText = {t('circle.symbology.label')}
          // Barcode Length
          labelHtmlFor = "symbology_cef"
          tippyAlertText = {t('circle.symbology.tippyContent')}
          tippyText      = {Constants.DOT}
        />
        {/* How many digits are in the barcodes of the products you buy? */}
      </td>
      <td>
        <select
          key="53"
          type="text"
          id="symbology_cef"
          name="symbology"
          onChange={handleChange}
          value={formData.symbology}
          required
        >
          <option value="upca">{t('circle.symbology.optionValue0')}</option>
          {/* <option value="upca">12 digits (US and Canada)</option> */}
          <option value="ean13">{t('circle.symbology.optionValue1')}</option>
          {/* <option value="ean13">13 digits (most of the world)</option> */}
        </select>
        &nbsp;*
      </td>
    </tr>
    <tr>
      <td>
        <HeadingBuilder
          containerType  = 'container-input-label'
          headingText    = {t('circle.topoff.label')}
            // Top Off level
          labelHtmlFor = "topoff_cef"
          tippyAlertText = {t('circle.topoff.tippyContent', {
            orderRange: t('ordersList.range_note_col.orderRangeLabel'),
          })}
          tippyText      = {Constants.DOT}
          // This is the level of 'top off' your Circle has agreed to...
          tippyInfoText  = {t('circle.topoff.tippyContentInfo')}
          // As an example of 'topping off': A case of soda has 24 cans..
        />
      </td>
      <td>
        <select
          key="54"
          type="text"
          id="topoff_cef"
          name="topoff_level"
          onChange={handleChange}
          value={formData.topoff_level}
        >
          {/* Renders, high to low: 100% (no top off), 95% (top off 5%),
              90% (top off 10%) ... 55% (top off 45%), 50% (top off 50%) */}
          {topoffOptions}
        </select>
        &nbsp;
      </td>
    </tr>
    <tr>
      <td>
        <HeadingBuilder
          containerType  = 'container-input-label'
          headingText    = {t('circle.share_sku_basic.label')}
            // Share basic Sku info
          labelHtmlFor   = "share_sku_basic_cef"
          tippyAlertText = {t('circle.share_sku_basic.tippyContent', {
              shareDetails: t('sku.shareable.label'),
          })}
          tippyText      = {Constants.DOT}
          // A 'yes' value here allows ShopWeAll to copy basic information...
          tippyInfoText  = {t('circle.share_sku_basic.tippyContentInfo', {
              shareDetails: t('sku.shareable.label'),
              details: t('sku.detail.label'),
          })}
        />
      </td>
      <td>
        <select
          key="55"
          type="text"
          id="share_sku_basic_cef"
          name="share_sku_basic"
          onChange={handleChange}
          value={formData.share_sku_basic}
        >
          {/* <option value="0">No</option> */}
          <option value="0">{t('shopper.showVideoTipsIcon.optionValue0')}</option>
          {/* <option value="1">Yes</option> */}
          <option value="1">{t('shopper.showVideoTipsIcon.optionValue1')}</option>
        </select>
      </td>
    </tr>
    <tr>
      <td>
        <HeadingBuilder
          containerType  = 'container-input-label'
          headingText    = {t('circle.tax_rate.label')}
          // Sales Tax Rate
          labelHtmlFor   = "tax_rate_cef"
          tippyAlertText = {circleTaxText}
          tippyText      = {circleTaxText}
        />
      </td>
      <td>
        <NumericFormat displayType="input"
          key="60"
          type="text"
          id="tax_rate_cef"
          name="tax_rate"
          onChange={handleChange}
          value={formData.tax_rate}
          decimalScale={3}
        />
        &nbsp;%
      </td>
    </tr>
    <tr>
      <td>
        <HeadingBuilder
          containerType  = 'container-input-label'
          headingText    = {t('circle.tax_rate_food.label')}
          // Food Sales Tax Rate
          labelHtmlFor   = "tax_rate_food_cef"
          tippyAlertText = {circleFoodTaxText}
          tippyText      = {circleFoodTaxText}
        />
      </td>
      <td>
        <NumericFormat displayType="input"
          key="70"
          type="text"
          id="tax_rate_food_cef"
          name="tax_rate_food"
          onChange={handleChange}
          value={formData.tax_rate_food}
          decimalScale={3}
        />
        &nbsp;%
      </td>
    </tr>
  </tbody>
</Table>

      {/* // detail: '',
      // img_url: '',
      // city: '',
      // county: '',
      // state: '',
      // country: '', */}

        {/* TODO: ?Will translating Submit be handled automatically by html?
            https://www.w3.org/International/wiki/Locale-based_forms */}
          <input key="170" type='submit' value='Submit' />
        </form>
        { errorsDoExist && <ErrorList /> }
        <BackButton />
      </article>
     )
    } else {
      return (
        <HeadingBuilder
          Size = 'h3'
          headingText = {t('global.notSignedInMessage')}
          // Not Authorized - Please Sign in or Sign up
        />
      )
    }
}

export default CircleEditForm;